var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showSeal)?_c('a',{staticClass:"badge badge-ekomi",attrs:{"href":"https://www.ekomi.de/bewertungen-zaun24.de.html","target":"_blank","aria-label":"Ekomi Bewertungen"}},[(_vm.sealImg)?_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(_vm.sealImg),expression:"sealImg"}],attrs:{"alt":"Ekomi"}}):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }